// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"ec85b376","354":"a5289255"}[chunkId] + ".css";
};